export const PV_SETUP_IMG_FOLDER = './images/onboarding/pv_setup/';

export const pvSetUpWizardItems = [
	{
		titleKey: 'pv_setup_info_modal_modes',
		title: 'Modes',
		type: 'Modes',
		subtitleKey: 'pv_setup_info_modal_modes_subtitle',
		subtitle: 'Understanding PV Modes',
		active: true,
		disabled: false,
		showMoreDots: false,
		stepNumber: 1,
		activeIndex: 0,
		images: [
			{
				src: 'pv_setup_info_modal_modes_parallel',
				class: 'image-wrapper',
				title: {
					key: 'pv_setup_type_parallel',
					default: 'Parallel',
				},
			},
			{
				src: 'pv_setup_info_modal_modes_backup',
				class: 'image-wrapper',
				title: {
					key: 'pv_setup_type_backup',
					default: 'Back UP',
				},
			},
			{
				src: 'pv_setup_info_modal_modes_balcony',
				class: 'image-wrapper',
				title: {
					key: 'pv_setup_type_balcony',
					default: 'Balcony PV',
				},
			},
		],
		bullets: [
			{
				key: 'pv_setup_info_modal_modes_description',
				default:
					'Each PV mode uses a different calculation to show how energy flows between your solar system, home, and the grid. The next steps break down how these calculations work for each mode.',
				style: '',
			},
		],
	},
	{
		titleKey: 'pv_setup_type_parallel',
		title: 'Parallel',
		type: 'Parallel',
		subtitleKey: 'pv_setup_info_modal_balcony',
		subtitle: 'Create and Manage Sequences',
		active: false,
		disabled: false,
		showMoreDots: false,
		stepNumber: 2,
		activeIndex: 1,
		images: [
			{
				src: 'pv_setup_info_modal_modes_parallel_image',
				title: null,
				class: null,
			},
		],
		bullets: [
			{
				key: 'pv_setup_info_modal_parallel_description_1',
				default:
					'In the Parallel setup (standard grid-tied), PV and grid power the home together and any excess PV is exported.',
				style: '',
			},
			{
				key: 'pv_setup_info_modal_parallel_description_2',
				default: 'House consumption = Grid source + PV generation − Exported',
				style: 'text-italic',
			},
		],
	},
	{
		titleKey: 'pv_setup_type_backup',
		title: 'BackUP',
		type: 'BackUP',
		subtitleKey: 'pv_setup_info_modal_backup',
		subtitle: 'Back Up Mode',
		active: false,
		disabled: false,
		showMoreDots: false,
		stepNumber: 3,
		activeIndex: 2,
		images: [
			{
				src: 'pv_setup_info_modal_modes_backup_image',
				title: null,
				class: null,
			},
		],
		bullets: [
			{
				key: 'pv_setup_info_modal_backup_description_1',
				default:
					'The grid is the primary supply, and PV acts as a secondary/backup supply. During outages, PV can keep essential circuits running if supported by the system.',
				style: '',
			},
			{
				key: 'pv_setup_info_modal_backup_description_2',
				default: 'Actual PV generation = Reported “Generated” − Grid source − Exported',
				style: 'text-italic',
			},
		],
	},
	{
		titleKey: 'pv_setup_type_balcony',
		title: 'Balcony PV',
		type: 'BalconyPV',
		subtitleKey: 'pv_setup_info_modal_balcony',
		subtitle: 'Balcony PV Mode',
		active: false,
		disabled: false,
		showMoreDots: false,
		stepNumber: 3,
		activeIndex: 2,
		images: [
			{
				src: 'pv_setup_info_modal_modes_balcony_image',
				title: null,
				class: null,
			},
		],
		bullets: [
			{
				key: 'pv_setup_info_modal_balcony_description_1',
				default:
					'Small plug-in PV panels reduce the circuit’s consumption directly. The PV device must report negative values when producing, as it behaves like a “negative load.”',
				style: '',
			},
			{
				key: 'pv_setup_info_modal_balcony_description_2',
				default: 'Consumption = Grid source + Generated − Exported',
				style: 'text-italic',
			},
		],
	},
];
